import { motion } from "framer-motion";
import { ButtonPrimary, ButtonGhostLight } from "./Buttons";
import { EASE } from "../../lib/motion";

const NODES = [
  { x: 8, y: 22 }, { x: 22, y: 62 }, { x: 38, y: 14 }, { x: 55, y: 70 },
  { x: 68, y: 24 }, { x: 84, y: 58 }, { x: 93, y: 16 }, { x: 14, y: 82 }, { x: 47, y: 40 }, { x: 78, y: 84 },
];
const LINKS = [[0, 8], [8, 1], [1, 9], [9, 3], [3, 4], [4, 6], [6, 5], [5, 2], [2, 0], [3, 7]];

export default function CTASection() {
  return (
    <section className="relative overflow-hidden" data-testid="final-cta-section">
      <div className="dark-section relative rounded-[2rem] px-6 py-24 text-center sm:px-12 lg:mx-4 lg:py-28">
        <svg className="absolute inset-0 h-full w-full opacity-60" viewBox="0 0 100 100" preserveAspectRatio="none" fill="none" aria-hidden="true">
          {LINKS.map(([a, b], i) => (
            <motion.line
              key={i}
              x1={NODES[a].x} y1={NODES[a].x <= 100 ? NODES[a].y : 0}
              x2={NODES[b].x} y2={NODES[b].y}
              stroke="url(#ctaGrad)" strokeWidth="0.18" strokeDasharray="1.4 1.4"
              className="animate-dash-flow"
              initial={{ pathLength: 0, opacity: 0 }}
              whileInView={{ pathLength: 1, opacity: 0.7 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, delay: i * 0.12 }}
            />
          ))}
          {NODES.map((n, i) => (
            <motion.circle
              key={i}
              cx={n.x} cy={n.y} r="0.55" fill="#38BDF8"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: [0.2, 1, 0.2] }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ delay: i * 0.25, duration: 3, repeat: Infinity }}
            />
          ))}
          <defs>
            <linearGradient id="ctaGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#2563EB" />
              <stop offset="100%" stopColor="#38BDF8" />
            </linearGradient>
          </defs>
        </svg>

        <div className="relative mx-auto max-w-2xl">
          <motion.span
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: EASE }}
            className="eyebrow justify-center text-slate-400 before:bg-sky-400"
          >
            Hablemos
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75, delay: 0.08, ease: EASE }}
            className="mt-5 text-4xl font-extrabold text-white sm:text-5xl"
          >
            ¿Listo para transformar <span className="text-gradient">tu operación?</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75, delay: 0.16, ease: EASE }}
            className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-slate-400 sm:text-lg"
          >
            Hablemos sobre cómo podemos ayudarte a convertir tecnología en resultados.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75, delay: 0.24, ease: EASE }}
            className="mt-10 flex flex-wrap items-center justify-center gap-4"
          >
            <ButtonPrimary to="/contacto" testid="final-cta-demo-button">Solicitar una demo</ButtonPrimary>
            <ButtonGhostLight to="/contacto" testid="final-cta-specialist-button">Hablar con un especialista</ButtonGhostLight>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
